'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return [{
    title: '首页',
    icon: '',
    router: '/',
    firstView: 'index'
  }, {
    title: '优课推荐',
    icon: '',
    router: '/course/course-list',
    firstView: 'course'
  }, {
    title: '党校微课',
    icon: '',
    router: '/microLesson/microLesson-list',
    firstView: 'microLesson',
    queryCategoryCode: 'dxwk'
  }, {
    title: '京彩直播',
    icon: '',
    router: '/jingcaizhibo/jingcaizhibo-list',
    firstView: 'jingcaizhibo'
  }, {
    title: '业务工作进党校',
    icon: '',
    router: '/workVideo/workVideo-list',
    firstView: 'workVideo',
    queryCategoryCode: 'ywsp'
  }, {
    title: '应用推荐',
    icon: '',
    router: '/applicationRecommend/applicationRecommend-list',
    firstView: 'applicationRecommend'
    // {
    //   title: '课程超市',
    //   icon: 'read-fill',
    //   lan: 'course',
    //   router: '/course/course-list',
    //   firstView: 'course'
    // },
    // {
    //   title: '班级中心',
    //   icon: 'flag-fill',
    //   lan: 'project',
    //   router: '/project/project-list',
    //   firstView: 'project'
    // },
    // {
    //   title: '考试练习',
    //   icon: 'edit-fill',
    //   lan: 'examPractice',
    //   router: '/examlist',
    //   firstView: 'examlist'
    // },
    // {
    //   title: '岗位',
    //   icon: 'contacts-fill',
    //   lan: 'dataDownLoad',
    //   router: '',
    //   firstView: '1'
    // },
    // {
    //   title: '技能',
    //   icon: 'appstore-fill',
    //   lan: 'dataDownLoad',
    //   router: '',
    //   firstView: '2'
    // },
    // {
    //   title: '学习资讯',
    //   icon: 'compass-fill',
    //   lan: 'dataDownLoad',
    //   router: '/dynamicList',
    //   firstView: 'dynamic'
    // },
    // {
    //   title: '资源中心',
    //   icon: 'file-text-fill',
    //   lan: 'resources',
    //   router: '/resources',
    //   firstView: 'resources'
    // }
    // {
    //   title: '活动｜直播',
    //   icon: 'flag-fill',
    //   lan: 'activity',
    //   router: '/activityCenter',
    //   firstView: 'activity'
    // },
    // {
    //   title: '老年大学',
    //   icon: 'build-fill',
    //   lan: 'agedUnivercity',
    //   router: '/channel/channelColumn?columnID=bjlnkfdx',
    //   firstView: 'bjlnkfdx'
    // },
    // {
    //   title: '家长培训',
    //   icon: 'book-fill',
    //   lan: 'project',
    //   router: 'https://jzpx.bjlearning.cn',
    //   firstView: 'project'
    // },
    // {
    //   title: '学习地图',
    //   icon: 'image-fill',
    //   lan: 'learnMap',
    //   router: '/learnMap',
    //   firstView: 'learnMap'
    // },
    // {
    //   title: '体验基地',
    //   icon: 'location-fill',
    //   lan: 'experience',
    //   router: '/experienceBase',
    //   firstView: 'experience'
    // }
    // {
    //   title: '个人中心',
    //   icon: 'user-fill',
    //   lan: 'userInfo',
    //   router: '/usercenter/myactivity',
    //   firstView: 'usercenter'
    // }
  }];
};